import CustomizedTitle from '../../../components/customizedTitle/CustomizedTitle';
import { addTrackingUrls } from '../../../utils/helpers/trackingURLHelpers.js';
import ToggleButton from '../../../components/common/ToggleButton';
import { getDynamicSelectData } from '../../../utils/api/data.js';
import LaneviewToggleSection from './LanviewToggleSection.jsx';
import CircularProgress from '@mui/material/CircularProgress';
import SelectBox from '../../../components/common/SelectBox';
import SearchBar from '../../../components/common/SearchBar';
import DataGrid from '../../../components/tables/DataGridAG';
import Sidebar from '../../../components/sidebar/Sidebar';
import verifyToken from "../../../utils/tokenUtils.js";
import NavBar from '../../../components/navbar/NavBar';
import pageTitle from '../../../utils/pageTitles.json';
import fieldMap from '../../../utils/fieldMap.json';
import { config } from '../../../config/Constants';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Cookies from 'js-cookie';
import './shipmenttrack.css';
import Axios from 'axios';

const ShipmentTrack = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [toggle, setToggle] = useState('');
  const [toggleViewChange, settoggleValueViewChange] = useState('TMS');
  const [selectValue, setSelectValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tableSelect, setTableSelect] = useState('');
  const [toggleData, setToggleData] = useState([{}]);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldName, setFieldsName] = useState([]);
  const getCompany = () => { return Cookies.get('cp-cn'); }
  const company = getCompany();

  const searchConfig = { size: 'normal', keyPress: true }
  const dataObject = { data: rows, rowSelection: 'single', }
  const titleObject = { title: pageTitle[company]?.['Shipment Track'] };
  const selectObject = {label: 'Search By', menuItems: fieldName}

  const handleSelectValue = (selectedValue) => { setSelectValue(selectedValue); }
  const inputValue = (value) => { setSearchValue(value); }

  const getSelectFields= () => {
    const selectObject = fieldMap[company]['Shipment Track']['Select Fields']
    setFieldsName(selectObject)
  }
  
  const toggleObject = {
    toggleButtons: ['Product Details', 'Tracking Details', 'POD Attachment', 'BOL Attachment' ],
    rows: rows,
    tableSelection: tableSelect,
  }
  
  const toggleObjectViewChange = { 
    toggleButtons: ['TMS', 'Parcel'], 
    tableSelection: toggleViewChange,
    rows: rows, 
  }

  useEffect(() => {
    const token = Cookies.get('gtms-cp-auth');
    token ? verifyToken(token) : navigate('/');
    const role = Cookies.get('cp-role');
    if (role == 'VENDOR') { navigate('/formslanding') };
    getSelectFields();
  }, []);

  const onSearch = (value) => {
    setSearchValue(value);
    handleSubmit();
  }

  const tableSelection = (value) => {
    setToggle(null);
    setTableSelect('');
    setTableSelect(value);
  }

  const handleSubmit = async() => {
    setIsLoading(true);
    let shipmentDataObject = await getTableData(toggleViewChange);
    if (toggleViewChange === 'Parcel') {
      shipmentDataObject = await addTrackingUrls(shipmentDataObject.data);
    }
    applyDataToRows(shipmentDataObject);
    setToggleData({});
    setToggle('');
    setIsLoading(false);
  }

  const getTableData = async (type) => {
    const response = await Axios.get(config.url.GET_LANEVIEW_SHIPMENT, {
      params: { type: type, selectValue: selectValue,
        searchValue: searchValue, company: company
      }
    });
    return response.data;
  };

  const applyDataToRows = (dataObj) => {
    const hasData = dataObj?.data?.length > 0;
    setRows(hasData ? dataObj.data : []);
  };
  
  const toggleValue = async(value) => {
    setToggle(value);
    const data = await getTableToggle(value);
    setToggleData(data);
  }

  const toggleValueViewChange = async(value) => {
    settoggleValueViewChange(value);
    if (value === 'Parcel'){
      setIsLoading(true);
      const response = await getDynamicSelectData({
        selectValues: 'TOP 1000 * EXCLUDE(CUSTOMER_NAME)', tableName: 'REPORT.PARCEL_SHIPMENT_TRACKER',
        whereField: ['CUSTOMER_NAME', 'CUSTOMER_NAME'], whereOperators: ['=', '!='], whereValue: [company, 'Purple'],
        orderBy: '"SHIP DATE" DESC', db: 'SF',
      });
      const updatedData = await addTrackingUrls(response);
      applyDataToRows(updatedData);
      setIsLoading(false);
    }
    else {
      setRows([]);
    }
  }
  
  const getTableToggle = async(toggle) => {
    const response = await Axios.get(config.url.GET_LANEVIEW_TOGGLE_DATA, {
      params: {
        toggle: toggle,
        tableRow: tableSelect,
      }
    });
    return response.data.data;
  }

  return (
    <div className="LandingPage">
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="laneviewPageContent">
          <div className="laneviewPageContentTop">
            <CustomizedTitle titleObject={titleObject}/>
            <div className="laneviewToggle">
              <ToggleButton toggleValue={toggleValueViewChange} toggleObject={toggleObjectViewChange} />
            </div>
          </div>
          <div className="laneviewPageContentMid">
            <div className="laneviewSearching">
            {toggleViewChange === 'TMS' ? (
              <div className="laneviewSelectBox">
                <SelectBox selectValue={handleSelectValue} selectObject={selectObject}/>
              </div>
              ) : (<div> </div>)}
              <div className="laneviewSearch">
                <SearchBar 
                  inputValue={inputValue} 
                  onSearch={onSearch} 
                  config={{...searchConfig, label: toggleViewChange === 'TMS' ? 'Search' : 'Search Tracking Number',}}
                />
              </div>
              <div className="lanviewSubmitSearch">
                <Button onClick={handleSubmit} variant='contained' disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} /> : 'Submit'}
                </Button>
              </div>
            </div>
            <div className="laneviewRow2">
              <div className="laneviewShipmentBoard">
                <DataGrid dataObject={dataObject} tableSelection={tableSelection}/>
              </div>
            </div>
          </div>
            <LaneviewToggleSection
              toggleViewChange={toggleViewChange}
              toggle={toggle}
              rows={rows}
              toggleObject={toggleObject}
              toggleValue={toggleValue}
              getTableToggle={getTableToggle}
              toggleData={toggleData}
            />
        </div>
      </div>
    </div>
  )
}

export default ShipmentTrack